import { Flex, Text } from "@fluentui/react-northstar";
import { Question, QuestionType, TeamsSurveyResponse } from "@teams/types";
import { ReactElement, useMemo } from "react";

import { PollyIcon } from "../../../../_shared/components/PollyIcon";
import { ChoiceQuestion } from "../components/QuestionVoteField";

export const useUserResponseValue = (
  question: Question<QuestionType>,
  response: TeamsSurveyResponse | undefined
) => {
  return useMemo(() => {
    if (!response) {
      return null;
    }

    const qr = response.responses.find(r => r.questionId === question.id);
    if (!qr) {
      return null;
    }

    let value: ReactElement | undefined;

    if (question.questionType !== "open-ended") {
      const choices = (question as unknown as ChoiceQuestion).choices.filter(c =>
        qr.value.includes(c.id)
      );

      if (choices.length > 0) {
        value = (
          <Flex column vAlign="start" hAlign="start">
            {choices.map((choice, index) => {
              return (
                <Flex vAlign="start" key={index + "-choice"}>
                  {choice.correct !== undefined && (
                    <PollyIcon
                      icon={choice.correct ? "correct-icon" : "incorrect-icon"}
                      style={{
                        marginRight: "3px",
                        marginTop: "4px",
                        color: choice.correct ? "#a7f3d1" : "#fca5a5",
                      }}
                      inheritColor
                    />
                  )}
                  <Text
                    content={choice.label || (choice.value as string)}
                    styles={{ wordBreak: "break-all" }}
                  />
                </Flex>
              );
            })}
          </Flex>
        );
      }
    } else {
      value = <Text content={qr.value as string} />;
    }

    return value;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [question, response?.id, response?.completed]);
};
